export enum StompMessageKind {
  RECORDER = "recorder",
  RECORDER_GROUP = "recorderGroup",
  USER = "user",
  USER_GROUP = "userGroup",
  ORGANIZATION = "account",
  VIDEO_SHARE = "videoShare",
  REPORT = "report",
  SITE_NOTICE = "siteNotice",
  RELEASE = "release",
  ASSIGN = "ASSIGN",
  CAMERA = "camera",
  COMMENT = "COMMENT",
  SUBSCRIPTION = "Subscription",
  ALERT_RULE = "RULE",
  MAPVIEW = "MAPVIEW",
  FIRMWARE = "firmware",
  PLAN = "plan",
}
export type DefaultSocketMessageEventType = "ADD" | "DELETE" | "UPDATE";
export type SocketMessageEventType = DefaultSocketMessageEventType | "warn";
export type MapSocketMessageEventType =
  | DefaultSocketMessageEventType
  | "FORCE"
  // | "REGISTER"
  | "DEREGISTER";

export interface StompMessageBody {
  kind: StompMessageKind;
  payload: any;
}
